export default {
    DRIVER_TYPE: {
        AMP: 'SEAmp',
        DIFF_AMP: 'DiffAmp',
    },

    ADC_TYPE: {
        DIFF: 'DiffADC',
        SE: 'SEADC',
    },

    SOURCE_TYPE: {
        SE: 'SESource',
        DIFF: 'DiffSource',
    },

    TOPOLOGY: {
        1: 'Inverting',
        2: 'NonInverting',
        3: 'Follower',
    },

    TEMPLATE_NAMES: {
        READ: 'readme',
        DRIVER: 'SUBCKT-OPAMP-ADAxxxx',
        ADC: 'SUBCKT-<<adcType>>-ADxxxx',
        TITLE_AND_POWER_TRANSIENT: 'Title-and-Power_Transient',
        TITLE_AND_POWER_MUXED_TRANSIENT: 'Title-and-Power-Muxed_Transient',
        TITLE_AND_POWER_NOISE: 'Title-and-Power_Noise',
        TITLE_AND_POWER_OPRANGE: 'Title-and-Power_OpRange',
        DRIVER_AND_SOURCE: 'Driver-and-Source_<<adcType>>_<<sourceType>>_<<ampType>>_<<topology>>',
        DRIVER_AND_SOURCE_MUXED: 'Driver-and-Source-Muxed_<<adcType>>_<<sourceType>>_<<ampType>>_<<topology>>',
        ADC_AND_RC_TRANSIENT_LT_SPICE: 'ADC-and-RC_Transient_<<adcType>>-<<ADCSchematicTemplate>>',
        ADC_AND_RC_TRANSIENT: 'ADC-and-RC_Transient_<<adcType>>',
        ADC_AND_RC_NOISE: 'ADC-and-RC_Noise_<<adcType>>',
        ADC_AND_RC_FFT: 'ADC-and-RC_FFT_<<adcType>>-<<ADCSchematicTemplate>>',
        TRANSIENT: 'PLT_Trans_<<adcType>>',
        MUXED: 'PLT_TransMuxed_<<adcType>>',
        NOISE: 'PLT_Noise',
        OPRANGE: 'PLT_OpRange_<<adcType>>',
        FFT: 'PLT_FFT_<<adcType>>',
        TOOL: 'tool',
    },

    FILE_NAMES: {
        READ: 'readme',
        DRIVER: 'SUBCKT-driver-<<Drivername>>',
        ADC: 'SUBCKT-adc-<<ADC>>',
        TRANSIENT: 'Kickback simulation schematic for <<ADCname>> and <<Drivername>>',
        MUXED: 'MuxedKickback simulation schematic for <<ADCname>> and <<Drivername>>',
        NOISE: 'Noise simulation schematic for <<ADCname>> and <<Drivername>>',
        OPRANGE: 'Operating Range simulation schematic for <<ADCname>> and <<Drivername>>',
        FFT: 'FFT simulation schematic for <<ADCname>> and <<Drivername>>',
        TOOL: '<<title>> - <<ADCname>> and <<Drivername>> configuration.url',
    },

    TEMPLATE_OVERRIDES: {
        'SUBCKT-OPAMP-ADAxxxx': 'SUBCKT-driver-<<Drivername>>',
        'SUBCKT-SEADC-ADxxxx': 'SUBCKT-adc-<<ADC>>',
        'SUBCKT-DiffADC-ADxxxx': 'SUBCKT-adc-<<ADC>>',
    },
};
